import { getDetectLiveClustering3 } from "./../api/detect";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useLocation } from "react-router-dom";
import { GetDetectLiveClustering3Params } from "../types/types";
import userStorage from "../utils/userStorage";

const useGetDetectLiveClustering3 = ({
  area,
  mobility_code = -1,
  searchKey = "",
  eps,
  level,
  minPts,
  swlng,
  swlat,
  nelng,
  nelat,
  startDate,
  endDate,
  event_code,
  groupId,
}: GetDetectLiveClustering3Params) => {
  const location = useLocation();
  const user = userStorage.get();

  const { data, isSuccess, isLoading, isError, isPlaceholderData } = useQuery({
    queryKey: [
      "DetectLiveClustering3",
      `mobility_code-${mobility_code}`,
      `searchKey-${searchKey}`,
      `area-${area}`,
      `eps-${eps}`,
      `swlng: ${swlng}`,
      `swlat: ${swlat}`,
      `nelng: ${nelng}`,
      `nelat: ${nelat}`,
      `startDate: ${startDate}`,
      `endDate: ${endDate}`,
      `event_code: ${event_code}`,
      `groupId: ${groupId}`,
    ],
    queryFn: () =>
      getDetectLiveClustering3({
        mobility_code,
        searchKey,
        area,
        eps,
        level,
        minPts,
        swlng,
        swlat,
        nelng,
        nelat,
        startDate,
        endDate,
        event_code,
        groupId,
      }),
    retry: false,
    enabled:
      location.pathname !== `/login` &&
      location.pathname !== `/maintenance` &&
      !!user,
    // 한 번 받은 범위는 10초 동안 그대로 쓴다 (왔다갔다 하는 이동에서 재조회 방지)
    staleTime: 1000 * 10,
    // 범위가 바뀌어도 이전 클러스터를 그대로 두고 뒤에서 새로 받는다
    placeholderData: keepPreviousData,
  });

  return { data, isSuccess, isLoading, isError, isPlaceholderData };
};

export default useGetDetectLiveClustering3;
